import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'
import AboutApp from '#app/components/about-app.tsx'
import AboutUs from '#app/components/about-us.tsx'
import AppBenefitsStatistics from '#app/components/app-benefits-statistics.tsx'
import Applinks from '#app/components/app-link.tsx'
import AppBenefits from '#app/components/benefits.tsx'
import ClickRate from '#app/components/click-rate.tsx'
import Footer from '#app/components/footer.tsx'
import Founders from '#app/components/founders.tsx'
import GrowthFeatures from '#app/components/growth-features.tsx'
import Hero from '#app/components/hero.tsx'
import HowItWorks from '#app/components/how-it-works.tsx'
import Pricing from '#app/components/pricing.tsx'
import ProgressTracker from '#app/components/progress-tracker.tsx'
import ReasonsForApp from '#app/components/reasons-for-app.tsx'

export const meta: MetaFunction = () => [{ title: 'Notify' }]

export default function Index() {
	return (
		<main className="flex w-full flex-col pt-32">
			<Hero />
			<AppBenefits />
			<GrowthFeatures />
			<AboutApp />
			<ClickRate />
			<AboutUs />
			<ReasonsForApp />
			<HowItWorks />
			<AppBenefitsStatistics />
			{/* <div className="relative z-10 mb-28 mt-32 hidden lg:block"> */}
			{/* <Reviews /> */}
			<Pricing />
			<div className="relative -top-20 z-10 flex justify-center">
				<ProgressTracker />
			</div>
			<div className="mb-36 flex justify-center">
				<button className="flex justify-center rounded-[90px] bg-primary px-14 py-4 text-white">
					<Link to="#contact">Rezervovat implementaci</Link>
				</button>
			</div>
			{/* </div> */}
			<Founders />
			<Applinks />
			{/* <Contact /> */}
			<Footer />
		</main>
	)
}
